import { Box, Button, Link, Typography } from '@mui/joy'
import { FRONTEND_URL } from '../constants'
import Layout from '../Layout'

const ExtensionHomePage = () => {
	return (
		<Layout>
			<Box sx={{
				textAlign: "center",
				display: "flex",
				alignItems: "center",
				justifyContent: "center",
				flexDirection: "column"
			}}>
				<Typography level='h4' >WebMark</Typography>
				<Typography level='body1' >Manage links in a smarter way</Typography>
				<Link target="_blank" sx={{marginY: "20px"}} href={FRONTEND_URL+"/signin"}>
					<Button>
						Login
					</Button>
				</Link>

				<Link target="_blank" sx={{marginY: "20px"}} href={FRONTEND_URL+"/signup"}>
					<Button>
						Create New Account
					</Button>
				</Link>
			</Box>
		</Layout>
	)
}

export default ExtensionHomePage